/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';

import { Property } from 'school-space-client/components';
import { getDateStringWithYear } from 'school-space-utils/date';

const css = {
    propertyRow: theme => ({
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: theme.layout.baseline,
        [theme.helpers.mq('s')]: {
            marginBottom: theme.layout.baseline * 2
        }
    }),
    property: theme => ({
        width: '100%',
        [theme.helpers.mq('s')]: {
            paddingRight: theme.layout.baseline,
            width: 'auto',
            flexGrow: 1,
            flexShrink: 1,
            '&:first-of-type': {
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: theme.layout.tableColumnWidths.medium
            },
            '&:last-of-type': {
                paddingRight: 0
            }
        }
    })
};

const RecurringBookingSummary = ({ recurringBooking }) => {
    const { recurrence, startDate, endDate, location } = recurringBooking;

    return (
        <section>
            <div css={css.propertyRow}>
                <Property title="Repeats" styles={css.property}>
                    {recurrence}
                </Property>
                <Property title="Location" styles={css.property}>
                    {location}
                </Property>
            </div>
            <div css={css.propertyRow}>
                <Property title="Start date" styles={css.property}>
                    {getDateStringWithYear(startDate)}
                </Property>
                <Property title="End date" styles={css.property}>
                    {getDateStringWithYear(endDate)}
                </Property>
            </div>
        </section>
    );
};

RecurringBookingSummary.propTypes = {
    recurringBooking: PropTypes.objectOf(PropTypes.any).isRequired
};

export default RecurringBookingSummary;
